import { GsStructComponent } from '../component';

/** Reason why a share link is unavailable (set via the `reason` query parameter on the backend redirect). */
export enum ShareLinkUnavailableReason {
  Expired = 'Expired',
  Consumed = 'Consumed',
  NotYetValid = 'NotYetValid',
}

/** Structure definition for the ShareLinkUnavailable component. */
export interface GsStructShareLinkUnavailableComponent extends GsStructComponent<never> {
  /** The specified type-key for this struct */
  componentType: 'ShareLinkUnavailable';
}
